import { useCallback, useEffect, useState } from "react";
import { checkForReactNativeAttribute } from "./react-native";

export const IS_REACT_NATIVE_APP = "is-react-native-app";

type UseNativeAppCheck = {
  isReactNativeApp: boolean;
};

export default function useNativeAppCheck(): UseNativeAppCheck {
  const [isReactNativeApp, setIsReactNativeApp] = useState<boolean>(false);

  const updateIsReactNative = useCallback(() => {
    const hasReactNativeAtrribute = checkForReactNativeAttribute();
    if (!isReactNativeApp) {
      setIsReactNativeApp(hasReactNativeAtrribute);
    }
  }, [isReactNativeApp]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName &&
          mutation.attributeName === IS_REACT_NATIVE_APP
        ) {
          updateIsReactNative();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
    });

    updateIsReactNative();

    return () => {
      if (observer) observer.disconnect();
    };
  }, [updateIsReactNative]);

  return { isReactNativeApp };
}
